import React from 'react';
import { NavLink } from 'react-router-dom';

// Helper function to generate blog page URL with tag filter
const getBlogPageUrlWithTag = (tag) => `/blog?page=1&tag=${encodeURIComponent(tag)}`;

// Helper function to create a NavLink for a tag
export const createTagNavLink = (tag) => (
  <NavLink key={tag} to={getBlogPageUrlWithTag(tag)} className="badge bg-secondary me-2 text-decoration-none tag-link">
    {tag}
  </NavLink>
);

export default getBlogPageUrlWithTag;
